import type { MailboxInfo } from "owa-client-types";

export function isSharedMailboxForCategories(mailboxInfo: MailboxInfo): boolean {
    return mailboxInfo.type === "SharedMailbox" && mailboxInfo.mailboxRank === "Resource";
}
